import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Country } from '../../models';
import { HttpClient } from '@angular/common/http';
import { PaginationCountryRequest, CreateCountryRequest } from '../country';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { requestQuery } from '../../../@shared/untils';

@Injectable()
export class CountryService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
        ) {}
    public getCountries(request: PaginationCountryRequest, disableSpinner?: boolean): Observable<PaginationResponse<Country>> {
        if(!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.get<PaginationResponse<Country>>(`${API.COUNTRY.GET_COUNTRIES}?${requestQuery(request)}`)
            .pipe(tap(() => this._spinner.hide()));
    }
    public delete(id: string) {
        return this._http.delete(API.COUNTRY.DELETE(id))
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.DELETE_COUNTRY);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    public import(file: any) {
        const formData = new FormData();
        formData.append('file', file);
        return this._http.post(`${API.COUNTRY.IMPORT}`, formData)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.IMPORT_COUNTRY);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateCountries(models: CreateCountryRequest[]) {
        return this._http.put(`${API.COUNTRY.UPDATE_COUNTRIES}`, models)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_COUNTRY);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
}
